<template>
  <p>
    <player-link :playerId="playerId" label="игрок"/>
    (<router-link :to="{name: 'player_rushes', params: {playerId: playerId}}">ражи</router-link>)
  </p>
</template>

<script>
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'RushPlayerInfo',

  components: {
    PlayerLink,
  },

  props: {
    rushPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    playerId() {
      return this.rushPlayerId.playerId;
    },
  },
};
</script>
